import { IFramePlayerAbstractClass } from 'iframe/ts/player/abstract/IFramePlayerAbstractClass';
export class IFramePlayerModel extends IFramePlayerAbstractClass {
    #paramsVO;
    constructor(iframePlayer) {
        super(iframePlayer, 'IFramePlayerModel');
        this.appEventsHandler(this.#onAppEvent, []);
    }
    get paramsVO() {
        return this.#paramsVO;
    }
    set paramsVO(value) {
        this.#paramsVO = value;
    }
    get apiMetadata() {
        if (this.utils.Type.isArray(this?.paramsVO?.CONTENT?.apiMetadata) && this.paramsVO.CONTENT.apiMetadata.length > 0) {
            return this.paramsVO.CONTENT.apiMetadata[0];
        }
        return {};
    }
    #onAppEvent = (event) => {
        this?.logger?.log('onAppEvent:', event?.type, event);
    };
}
